import React from "react";
import Dialog from "@material-ui/core/Dialog/Dialog";
import styled from "styled-components";
import {TransitionProps} from "@material-ui/core/transitions";
import Slide from "@material-ui/core/Slide/Slide";

interface SearchPageProps {
    open: boolean;
    dismiss: () => void;
    children: any;
}

const StyledDialog = styled(Dialog)`
  background-color: white;
`;

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const SearchPage = (props: SearchPageProps) => {
    const {open, dismiss} = props;

    return (
        <StyledDialog
            fullScreen
            open={open}
            TransitionComponent={Transition}
            onClose={dismiss}
        >
            {props.children}
        </StyledDialog>
    );
};

export default SearchPage;